import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { PartnerItem, PartnersRequest, PartnersResponse } from './types'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}
const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const partnersListMounted = createEvent<PartnersRequest>()

export const getPartners = fx<PartnersRequest, PartnersResponse>({
  method: 'GET',
  url: `/promo/anniversary/partner`,
})

export const $partners = restore<PartnerItem[]>(
  getPartners.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfPartners = restore(
  getPartners.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: partnersListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }
    let newObj = {}

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    if (Object.keys(newObj).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getPartners,
})
